import { useHubTheming } from '~/clc/features/theming/providers/useHubTheming';
import { StyledThemeRichText } from './ThemeRichText.styles';

interface BaseThemeRichTextProps {
  dangerouslySetInnerHTML: { __html: string };
  themeFontColor?: string;
  themeButtonLinksColor?: string;
  className?: string;
  themeFontHeadingFamily?: string;
  themeFontHeadingSize?: number;
  themeFontBodySize?: number;
  themeFontBodyFamily?: string;
}

interface ThemeRichTextProps {
  dangerouslySetInnerHTML: { __html: string };
  themeTextColor?: string;
  buttonLinksColor?: string;
  className?: string;
}

const HUB_GENERAL = 'hub.general';

export const ThemeRichText = ({
  dangerouslySetInnerHTML,
  buttonLinksColor,
  themeTextColor,
  className,
}: ThemeRichTextProps) => {
  const { renderedThemeSettings } = useHubTheming();

  const hubGeneralSettings = renderedThemeSettings.find((ts) => ts.category === HUB_GENERAL).settings;
  const { colors: defaultHubColors, typography: defaultHubTypography } = hubGeneralSettings;

  const hubDefaultHeadingFontFamily = defaultHubTypography.heading;
  const hubDefaultFontBodyFamily = defaultHubTypography.body;
  const hubDefaultFontBodySize = defaultHubTypography.bodySize;
  const hubDefaultHeadingFontSize = defaultHubTypography.headingSize;
  const hubDefaultTextColor = defaultHubColors.text;
  const hubDefaultButtonLinksColor = defaultHubColors.buttonLinks;

  return (
    <BaseThemeRichText
      className={className}
      themeFontColor={themeTextColor || hubDefaultTextColor}
      themeFontHeadingFamily={hubDefaultHeadingFontFamily}
      themeFontHeadingSize={hubDefaultHeadingFontSize}
      themeFontBodySize={hubDefaultFontBodySize}
      themeFontBodyFamily={hubDefaultFontBodyFamily}
      themeButtonLinksColor={buttonLinksColor || hubDefaultButtonLinksColor}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    />
  );
};

export const BaseThemeRichText = ({
  dangerouslySetInnerHTML,
  themeButtonLinksColor,
  themeFontColor,
  className,
  themeFontHeadingFamily,
  themeFontHeadingSize,
  themeFontBodySize,
  themeFontBodyFamily,
}: BaseThemeRichTextProps) => (
  <StyledThemeRichText
    className={className}
    $fontColor={themeFontColor}
    $fontHeadingFamily={themeFontHeadingFamily}
    $fontHeadingSize={themeFontHeadingSize}
    $fontBodySize={themeFontBodySize}
    $fontBodyFamily={themeFontBodyFamily}
    $buttonLinksColor={themeButtonLinksColor}
    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
  />
);
